import * as z from 'zod'
import { TFunction } from 'react-i18next'

export const getReservationTimeNewFormSchema = (t?: TFunction) => {
  const schema = z
    .object({
      reservationDate: z.object({
        checkIn: z.date(),
        checkOut: z.date(),
      }),
      reservationTime: z.object({
        start: z.date(),
        end: z.date(),
      }),
      // .refine((data) => data?.start && data?.end && data.start < data.end),
      notes: z.string().default(''),
      customerCompanyId: z.string().nullable().default(null),
      customerPersonId: z.string().min(1),
      customerEmailAddress: z.string().nullable().optional(),
      // sendEmailAfterInsert: z.boolean(),
      resourceIds: z.string().array(),
      manualPrice: z.number(),
    })
    .superRefine((data, context) => {
      if (data.reservationDate.checkIn && data.reservationDate.checkOut) {
        if (!data.reservationTime) {
          context.addIssue({
            code: z.ZodIssueCode.custom,
            message: t?.('validation.required_error'),
            path: ['reservationTime.start'],
          })
          context.addIssue({
            code: z.ZodIssueCode.custom,
            message: t?.('validation.required_error'),
            path: ['reservationTime.end'],
          })
        }
        if (data.reservationTime.start === null)
          context.addIssue({
            code: z.ZodIssueCode.custom,
            message: t?.('validation.required_error'),
            path: ['reservationTime.start'],
          })
        if (data.reservationTime.end === null)
          context.addIssue({
            code: z.ZodIssueCode.custom,
            message: t?.('validation.required_error'),
            path: ['reservationTime.end'],
          })
      }
    })

  return schema
}

const schema = getReservationTimeNewFormSchema()

export type ReservationTimeSchema = z.TypeOf<typeof schema>
